class PressReleases {
  yearDropDown;
  catDropDown;
  prContainer;
  loader;
  constructor() {
    this.yearDropDown = $("#year_filter");
    this.catDropDown = $("#cat_filter");
    this.prContainer = $("#press-releases-container");
    this.loader = $("#press-releases-fetching-loader");
    // this.loader.addClass("show")
    this.initListeners();
  }

  initListeners = () => {
    if (!this.yearDropDown || !this.catDropDown)
      throw new Error("couldn't find filter elements");
    this.yearDropDown.on("change", this.fetch);
    this.catDropDown.on("change", this.fetch);
  };

  fetch = () => {
    let data = {
      action: "get_modfin_data",
      widget: "news_feed",
    };
    if (this.catDropDown.val())
      data.cat = this.catDropDown.val()
    if (this.yearDropDown.val()){
      data.year_from = this.yearDropDown.val()
      data.year_to = Number.parseInt(this.yearDropDown.val()) + 1
    }
    $.ajax({
      method: "post",
      data: data,
      url: "/wp-admin/admin-ajax.php",
      dataType: "json",
      success: (result) => {
        this.prContainer.html(result)
      },
      error: function (result) {
        console.log("error res", result);
      },
    });
  };
}

window.PressReleases = PressReleases;
